/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnimatedButton from '../../../components/Animation/AnimatedButton';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GloablContext';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import OrganizationExport from '../OrganizationExport';
import HelpGuideModal from '../../../components/HelpGuideModal';
import {useGetHelpGuideOrganizationQuery} from '../../../slices/patientSlice'
import { handleSidebarPrvState } from '../../../redux/systemConfigSlice';


const TopBarIndividual = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    buttonName,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    toAddScreen,
    isExport,
    setConfirmationState, data, exportUsers, isIdexport }) => {
    const { setToastErrorMessage, isSideBar,setIsSideBar,setIsAdvancedSearchOpen } = useContext(GlobalContext);
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)

    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state.MultiSelectSlice.selectedRows.selectedIds)
    const ref = useRef()
    const ref2 = useRef()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    function getSearchParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const result = {};

        searchParams.forEach((value, key) => {
            result[key] = value;
        });

        return result;
    }
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    useOnClickOutside(ref2, () => {
        setIsChangeStatusOpenxl(false)
    })



    function handleActivateClick(status) {
        if (selectedRows.map((item) => item.name).length > 50) {
            setToastErrorMessage(`You cannot ${status} more than 50 users at once`)
            setIsChangeStatusOpen(false)
            return
        }
        setIsChangeStatusOpen(false)
        if (status === "activate") {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'active', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
        else {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'deactive', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
    }
    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-list-users');
        } 
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    // Function to handle onClick logic for searchbar open
    const handleSearchClick = () => {
            
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
              
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };

    return (
        <>
            <div className="flex justify-between items-center mb-[14px]">
                <div className='flex justify-between items-center min-w-max'>
                    {title !== undefined ?
                        <h1 className="text-xl font-normal text-[#000000] min-w-fit 2xl:pt-0 pt-2 self-start 2xl:self-center">{title}</h1>
                        :
                        pathPlaceholder &&
                        <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='hidden items-center min-w-max xl:flex'>
                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                            <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                        </Link>
                    }
                    <span   onClick={() => setHelpGuideModel(true)} className='ml-2 cursor-pointer'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                </div>
            
            
                <div className="flex items-center w-full justify-end relative 2xl:flex-nowrap flex-wrap">
                    <div className=''>
                        {menuBar && <div className='relative 2xl:mb-0 mb-2.5'>
                            <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[12px] hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                                onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen) }}
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)}
                            >
                                {
                                    isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                                }
                            </button>
                            {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                                <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                                <li>
                                    <ul>
                                        <li>
                                            <AnimatedButton
                                                handleClick={(e) => { handleActivateClick("activate") }}
                                                buttonName={"Activate"}
                                                disabled={(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? true : false}
                                                className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? 'text-[#6e6d6d]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'} `}
                                            />
                                        </li>
                                        <li>
                                            <AnimatedButton
                                                handleClick={(e) => { handleActivateClick("deactivate") }}
                                                buttonName={"Deactivate"}
                                                disabled={(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? true : false}
                                                className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? 'text-[#706a6a]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'}  `}
                                            />
                                        </li>
                                    </ul>
                                </li>
                            </ul>}
                        </div>}
                    </div>
                    <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                    </button>
                    <div className='flex items-center'>
                        {(SearchInput || isExport) && data !== undefined && data?.organizationUsers?.length > 0 && <div className='2xl:mb-0 mb-2.5'>  <OrganizationExport
                            selectedRows={selectedRows}
                            exportUsers={exportUsers}
                            exportCols={exportCols}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            isIdexport={isIdexport} username={username} />
                        </div>}
                        {/* <button id="icon-import" disabled className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] relative cursor-pointer 2xl:mb-0 mb-2.5">
                        <img src="/images/download-red.svg" alt="download-icon" className='rotate-[180deg] cursor-pointer' />
                        <label htmlFor="upload"></label>
                        <input type="file" className='opacity-0 absolute top-0 left-0 w-full h-full cursor-pointer' disabled />
                    </button> */}
                        {isExport &&
                        <>{<Link to={''}>
                            <button type='button'
                                id="view_export_history"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:mb-0 mb-2.5`}>
                                View Export History
                            </button>
                        </Link>}</>}
                        {AddButton &&
                        <>{<Link to={toAddScreen} state={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"),"search_mode": searchParams.get("search_mode"), 'search': searchParams.get("search") ? searchParams.get("search") : '' }}>
                            <button type='button'
                                id="Add"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:mb-0 mb-2.5`} style={{ 'width': 'max-content' }}>
                                <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                                <span>{buttonName}</span>
                            </button>
                        </Link>}</>}
                    </div>
                </div>
            </div>
            {/* modal */}
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
      
    );
}

export default TopBarIndividual;
